import logoColored from "../../assets/logoColored.png";
import sass from "../../../../components/controllers/shared/styled/sass";

const colors = {
	white: sass.variables.color.white,
	darkBlue: sass.variables.color.darkBlue,
	mediumDarkBlue: sass.variables.color.mediumDarkBlue,
	gray4: sass.variables.color.gray4,
};

const fonts = {
	bold: sass.mixins.include.fontBold(),
	light: sass.mixins.include.fontLight(),
};

const nav = `
.navbar-static-top.navbar-default {
	background: ${colors.white};
	border-bottom: 1px solid #c5c6c5 !important;
}

.navbar-static-top.navbar-default .navbar-nav>li>a:focus, .navbar-default .navbar-nav>li>a:hover {
	background-color: #f6f6f8;
}

.navbar-static-top.navbar-default .navbar-nav>li>a {
	color: #333;
}

.mainNav li.navItemActive, .mainNav li.navItemActive:hover, .navbar-default .navbar-nav>li.navItemActive>a:hover  {
	height: inherit;
	border-bottom: 4px solid ${colors.darkBlue} !important;
}

.navbar-default .navbar-nav.mainNav .dropdown-menu:not(.nav-second-tier) {
	background: ${colors.white};
}

.navbar-default .navbar-nav.mainNav .dropdown-menu:not(.nav-second-tier) a:hover {
	background-color: #f6f6f8;
}

.logoWhite {
    width: 160px;
	background-image: url(${logoColored});
	background-size: 125px 36px;
	background-repeat: no-repeat;
}
.mainNav li a.logoWhite:hover, .mainNav li a.logoWhite:focus {
	background-color: transparent;
	outline-style: none;
    outline-color: transparent;
}
.mainMenuContainer {
	padding: 0px;
}

.webdemoMyAccountContent, .planningAndGuidanceContent {
	background: ${colors.white};
	border: none;
	border-radius: 0%;
	margin: 0 10px !important;
}

.webdemoMyAccountContent li a, .planningAndGuidanceContent li a {
	${fonts.light};
}

.webdemoMyAccountContent li {
	border-bottom: 1px solid ${colors.gray4};
}

.planningAndGuidanceContent li a {
	padding-left: 32px;
	padding-top: 15px;
	padding-bottom: 15px;
}

.planningAndGuidanceContent li span {
	width: 100%;
}

.planningAndGuidanceContent li span a:hover {
	color: #333;
}

.myProfileContent li a {
	padding-top: 10px;
	padding-bottom: 10px;
	font-size: 14px !important;
	display: inline-flex;
	align-items: center;
}

.myProfileContent li {
	margin-left: 25px;
}

a.myAccountLinks {
	color: #333;
	white-space: nowrap;
	display: block;
	font-size: 16px;
	${fonts.bold}
	width: 100%;
	padding: 25px 20px;
}
.mainNav .dropdown a.myAccountsActivator {
	color: #333;
	font-size: 16px;
	padding: 0px 15px;
	text-decoration: none;
	${fonts.bold}
}
.mainNav li.myAccounts .dropdown {
	display: table;
	height: 60px;
}
.navbar-nav .dropdown.open i {
	margin-bottom: -4px;
}
.myAccountsActivator {
	display: table-cell;
	vertical-align: middle;
}
.myAccountsActivator:hover {
	 background: #f6f6f8;
 }
.myAccountsActivator:focus, .myAccountsActivator:hover {
	text-decoration: none;
	color: ${colors.white};
}
.navbar-default .navbar-nav .dropdown.open>a.myAccountsActivator {
	background: #f6f6f8;
	color: #333;
}
.nav .open>a.myAccountsActivator:focus,
.navbar-default .navbar-nav .dropdown.open>a.myAccountsActivator:hover {
	text-decoration: none;
}
.noNav li.primaryNavOnItems, .noBack li.primaryNavBack {
	display: none;
}
li.primaryNavOnItems a {
	font-size: 16px;
}
.webdemoMyAccountsListMobile {
	position: relative;
	border:none;
	border-radius: 0px;
	padding: 0px;
	width: 100%;
	box-shadow: none;
}
.dropdown.open.btn-group, .dropdown.btn-group {
	width: 100%;
}
.myAccountsActivator .dropdown-caret {
	position: absolute;
	top: 0px;
	right: 20px;
}
.webdemoMyAccountsListMobile ul.webdemoMyAccountContent li {
	width: 100%;
}
.menu-dropdown-left-full .panel .panel-body .list-group .list-group-item a.list-group-item-mobile {
	background: #035fa4;
}

.profileAvatar {
	height: 40px;
	width: 40px;
	background: ${colors.white};
	display: inline-block;
	border-radius: 50%;
	border: 2px solid #e3f5fd;
	text-align: center;
	margin-right: 10px;
	padding-top: 8px;
	color: #0061a0;
	font-size: 14px;
}

.notificationIcon {
	background: #c00000;
	width: 10px;
	height: 10px;
	position: absolute;
	right: 12px;
	top: -8px;
	z-index: 2;
	border-radius: 50%;
}

.messageCount {
	background: #c00000;
	color: white;
	border-radius: 5px;
    margin-left: 35px;
    padding: 3px 5px;
}
`;

export default nav;
